import CompanyDetails from './CompanyDetails';
import convert from '../../lib/convert';
import getFlowContext from '../../lib/getFlowContext';
import { connect } from 'react-redux';
import { flags, setLoadingFlag } from '../../data/loading.redux';
import { saveFields } from '../../data/client.redux';
import { withRouter } from 'react-router-dom';
import { actions } from '../../lib/actions';
import { clearErrors, errorTypes, setError } from '../../data/error.redux';
import { datadogRum } from '@datadog/browser-rum';

const handleConvert = (client, payload, dispatch, redirect) => {
  dispatch(clearErrors([errorTypes.GENERIC, errorTypes.POST_ERROR, errorTypes.EMAIL_UNAVAILABLE]));
  dispatch(setLoadingFlag(flags.DETAILS_POST, true));
  return convert(actions.PROVIDED_COMPANY_DETAILS, {
    ...client,
    ...payload,
  })
    .then(() => {
      dispatch(saveFields({ ...payload }));
      dispatch(setLoadingFlag(flags.DETAILS_POST, false));
      redirect(getFlowContext().nextStep.path);
    })
    .catch(error => {
      dispatch(setLoadingFlag(flags.DETAILS_POST, false));
      dispatch(setError({ type: errorTypes.POST_ERROR }));
      datadogRum.addError('Provided company details Marketo API call failed', error);
    });
};

export const handleCompanyDetailsSubmit = ({ client, payload, redirect }) => {
  return dispatch => {
    if (!client.email) {
      dispatch(saveFields({ ...payload }));
      redirect(getFlowContext().nextStep.path);
    }

    if (client.email) {
      return handleConvert(client, payload, dispatch, redirect);
    }
  };
};

const mapStateToProps = state => ({
  client: state.client,
  hasTopBanner: state.error?.errors?.length > 0,
  isLoading: state.loading[flags.DETAILS_POST],
  isMaintenanceModeActive: state.ui.isMaintenanceModeActive,
});

const mapDispatchToProps = {
  handleCompanyDetailsSubmit,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyDetails));
